import React, { forwardRef, useMemo } from 'react';

import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';
import Tag from '@/modules/corporate/modules/database/fields/components/DatabaseSelect/components/Tag';
import getSelectedOptions from '@/modules/corporate/modules/database/fields/components/DatabaseSelect/utils/getSelectedOptions';
import useKeyboard from '@/modules/corporate/modules/database/fields/hooks/useKeyboard';
import { CellProps } from '@/modules/corporate/modules/database/types';

const MultiSelectCell = forwardRef<HTMLDivElement, CellProps>((props: CellProps, ref) => {
  const { toggleIsEditing, columnIndex, rowIndex, column, cellData, className } = props;

  const selectedOptions = useMemo(() => {
    const options = column.field.metadataField.options || [];

    if (!options.length || !cellData?.value) {
      return [];
    }

    return getSelectedOptions(options, cellData.value);
  }, [cellData?.value, column.field.metadataField.options]);

  const { onKeyDown } = useKeyboard({ onEnterPress: toggleIsEditing });

  return (
    <Box
      ref={ref}
      className={cn('flex w-full flex-wrap self-start p-8 pe-6', className)}
      data-colindex={columnIndex}
      data-rowindex={rowIndex}
      tabIndex={0}
      onClick={toggleIsEditing}
      onKeyDown={onKeyDown}>
      {selectedOptions.map((option) => (
        <Tag key={option.optionId} option={option} />
      ))}
    </Box>
  );
});

export default MultiSelectCell;
